import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import MUIButton from "@material-ui/core/Button";
import styles from "./styles/button.css.js";
import withStyles from "components/with-styles";

const Button = ({ className, children, classes, ...props }) => (
  <MUIButton className={cn(classes.button, className)} variant="contained" color="primary" {...props}>
    {children}
  </MUIButton>
);

Button.propTypes = {
  /**
   * Clase adicional del componente.
   */
  className: PropTypes.string,
};

export default withStyles(styles)(Button);
